import axios from '@/config/axios'


const holidayBase = '/v1/api/mg/holiday'


export const holidayList = (query) => axios.get(`${holidayBase}`, {params: query})
export const holidayCreate = (holiday) => axios.post(`${holidayBase}`, holiday)
export const holidayUpdate = (holiday) => axios.put(`${holidayBase}/${holiday.id}`, holiday)
export const holidayDelete = (id) => axios.get(`${holidayBase}/${id}`)


const feedBackTypeListBase = "/v1/api/mg/feedbackType"
export const feedBackTypeList = (query) => axios.get(`${feedBackTypeListBase}`, {params: query})

export const feedBackTypeCreate = (data) => axios.post(`${feedBackTypeListBase}`, data)
export const feedBackTypeUpdate = (data) => axios.put(`${feedBackTypeListBase}/${data.id}`, data)
export const feedBackTypeDelete = (id) => axios.delete(`${feedBackTypeListBase}/${id}`)

const bankBase = '/v1/api/mg/banks'

export const bankList = (query) => axios.get(`${bankBase}`, {params: query});
export const bankCreate = (data) => axios.post(`${bankBase}`, data);
export const bankUpdate = (data) => axios.put(`${bankBase}/${data.id}`, data);


const dictBase = "/v1/api/mg/dict";
export const getDict = (key) => axios.get(dictBase, {params: {"key": key}})

export const saveDict = (data) => axios.put(dictBase, data)

